/**
 * Брейкпоинт шапки ERP — ОДНО место на все её части (меню, пункт меню,
 * правая группа, блок пользователя).
 *
 * Шапка подогнана под 1280 px: шесть групп меню, колокольчик, палитра, язык,
 * профиль и выход. Уже 1280 она не помещалась — всё `nowrap`, и страница
 * получала горизонтальную прокрутку (на 1100 px — около 100 px лишних).
 * Ниже брейкпоинта шапка «ужимается»: меньше зазоры и разрядка, у профиля
 * только имя (полный адрес — в подсказке кнопки профиля). На ≥ 1280 вид
 * прежний.
 *
 * Лежит в `components/constants`, а не рядом с `organisms/Menu`: им
 * пользуются атом (`UserInfo`) и молекула (`MenuItem`), а импорт снизу вверх
 * по Atomic Design запрещён.
 */
export const HEADER_COMPACT_MAX = 1279;

/** Готовое медиа-условие для styled-components. */
export const HEADER_COMPACT_MEDIA = `@media (max-width: ${HEADER_COMPACT_MAX}px)`;

/**
 * ТЗ 0119: средняя ступень (1280–1535 px, в том числе 1440). Кнопка темы
 * (34 px + зазор) добавилась в правую группу, и у ролей с семью группами
 * меню (финансист: «Преподаватели») пункты налезли на колокольчик. Здесь —
 * только зазоры: между пунктами 12 вместо 16, в правой группе 8 вместо 12.
 */
export const HEADER_MID_MAX = 1535;

export const HEADER_MID_MEDIA = `@media (max-width: ${HEADER_MID_MAX}px)`;
